import { login as apiLogin } from '../api'

export default {
  namespaced: true,
  state: {
    accessToken: ''
  },
  getters: {
    isLogin: state => !!state.accessToken
  },
  mutations: {
    setToken (state, token = '') {
      state.accessToken = token
    }
  },
  actions: {
    async loginAction ({ commit }, { form }) {
      const data = await apiLogin(form.account, form.password)
      const accessToken = data.token_type + ' ' + data.access_token
      commit('setToken', accessToken)
      localStorage.setItem('access_token', accessToken)
      return accessToken
    },
    logoutAction (context) {
      context.commit('setToken')
      // console.log(`current toke is ${context.state.accessToken}`)
      localStorage.removeItem('access_token')
      context.dispatch('cart/clearCart', null, { root: true })
    },
    initAccessToken ({ commit }) {
      const accessToken = localStorage.getItem('access_token') || ''
      commit('setToken', accessToken)
    }
  }
}
